const POLICY = '/pages/terms-conditions';
const POLICY_VERSION = '2026-09-14T15:23:32Z';
const POLICY_SHA256 = '6a1092f6d8afbb7e7b727431ba3a58eaf9a25e2be65024881257c509e37d67df';
const PREFIX = 'OC Ramps Terms';
const endpoint = path => `${window.Shopify?.routes?.root || '/'}${path}`.replace(/\/\//g, '/');
let pending = false;
let clearPromise = Promise.resolve();
let acceptanceGeneration = 0;
let termsOpener = null;

document.addEventListener('click', event => {
  const link = event.target.closest?.('[data-native-cart-terms-open]');
  if (link) {
    const dialog = document.querySelector('#native-cart-terms-dialog');
    if (!dialog?.showModal || !dialog.querySelector('.native-cart-terms-dialog__content')?.textContent.trim()) return;
    event.preventDefault();
    event.stopPropagation();
    termsOpener = link;
    dialog.showModal();
    dialog.querySelector('[data-native-cart-terms-close]')?.focus();
    return;
  }
  if (event.target.closest?.('[data-native-cart-terms-close]')) document.querySelector('#native-cart-terms-dialog')?.close();
});
document.addEventListener('close', event => {
  if (event.target.id === 'native-cart-terms-dialog') termsOpener?.focus();
}, true);

async function cart() {
  const response = await fetch(endpoint('cart.js'), {credentials:'same-origin', cache:'no-store'});
  if (!response.ok) throw new Error('Cart could not be verified');
  return response.json();
}

function fingerprint(value) {
  return JSON.stringify({items:value.items.map(item=>[item.key,item.quantity]),total:value.total_price,currency:value.currency});
}

async function attributes(values) {
  const response = await fetch(endpoint('cart/update.js'), {
    method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({attributes:values})
  });
  if (!response.ok) throw new Error('Cart acceptance could not be saved');
  return response.json();
}

function controls() { return [...document.querySelectorAll('[data-native-cart-terms]')]; }
function syncButtons() {
  for (const control of controls()) {
    const button = control.parentElement?.querySelector('button[name="checkout"]');
    if (button) button.disabled = !control.querySelector('[data-native-cart-terms-checkbox]').checked || Boolean(window.__ocNativeCartEditorOpen);
  }
}
function clearUi() {
  for (const control of controls()) {
    control.querySelector('[data-native-cart-terms-checkbox]').checked = false;
    control.querySelector('[data-native-cart-terms-error]').hidden = true;
  }
  syncButtons();
}

async function clearAcceptance() {
  acceptanceGeneration++;
  clearUi();
  clearPromise = clearPromise.catch(()=>{}).then(()=>attributes({[`${PREFIX} Accepted`]:'',[`${PREFIX} Policy`]:'',[`${PREFIX} Policy Version`]:'',[`${PREFIX} Policy SHA256`]:'',[`${PREFIX} Accepted At`]:'',[`${PREFIX} Cart`] :''}));
  await clearPromise;
}

document.addEventListener('change', event => {
  const checkbox = event.target.closest?.('[data-native-cart-terms-checkbox]');
  if (checkbox) {
    if (!checkbox.checked) clearAcceptance().catch(()=>{});
    else for (const control of controls()) control.querySelector('[data-native-cart-terms-error]').hidden = true;
    syncButtons();
    return;
  }
  if (event.target.closest?.('cart-items-component')) clearAcceptance().catch(()=>{});
}, true);

document.addEventListener('click', event => {
  if (event.target.closest?.('cart-items-component .cart-items__quantity-controls, cart-items-component .cart-items__remove')) {
    clearAcceptance().catch(()=>{});
  }
}, true);
document.addEventListener('cart:update', () => clearAcceptance().catch(()=>{}));
document.addEventListener('native-cart:editor-state', syncButtons);

document.addEventListener('click', async event => {
  const button = event.target.closest?.('button[name="checkout"]');
  if (!button || !button.closest('cart-items-component')) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (pending) return;
  const context = button.closest('cart-items-component');
  const checkbox = context.querySelector('[data-native-cart-terms-checkbox]');
  const error = context.querySelector('[data-native-cart-terms-error]');
  if (window.__ocNativeCartEditorOpen) return;
  if (!checkbox?.checked) {
    if (error) error.hidden = false;
    checkbox?.focus();
    return;
  }
  pending = true;
  window.__ocNativeCartCheckoutPending = true;
  button.disabled = true;
  try {
    await clearPromise;
    const generation = acceptanceGeneration;
    const before = await cart();
    const cartMark = fingerprint(before);
    const acceptedAt = new Date().toISOString();
    const after = await attributes({
      [`${PREFIX} Accepted`]:'Yes',
      [`${PREFIX} Policy`]:POLICY,
      [`${PREFIX} Policy Version`]:POLICY_VERSION,
      [`${PREFIX} Policy SHA256`]:POLICY_SHA256,
      [`${PREFIX} Accepted At`]:acceptedAt,
      [`${PREFIX} Cart`]:cartMark
    });
    if (fingerprint(after) !== cartMark || generation !== acceptanceGeneration || !checkbox.checked || window.__ocNativeCartEditorOpen) throw new Error('Cart changed during acceptance');
    const final = await cart();
    if (fingerprint(final) !== cartMark || final.attributes?.[`${PREFIX} Accepted At`] !== acceptedAt || generation !== acceptanceGeneration || !checkbox.checked || window.__ocNativeCartEditorOpen) throw new Error('Cart changed before checkout');
    window.location.assign(endpoint('checkout'));
  } catch {
    await clearAcceptance().catch(()=>{});
    if (error) { error.textContent='Your cart changed or acceptance could not be saved. Review your cart and accept the terms again.'; error.hidden=false; }
  } finally {
    pending = false;
    window.__ocNativeCartCheckoutPending = false;
    syncButtons();
  }
}, true);

// A fresh document never inherits acceptance from another tab or an abandoned checkout.
clearAcceptance().catch(()=>{});
// Back-forward cache restores the previous DOM without rerunning this script.
window.addEventListener('pageshow', () => clearAcceptance().catch(()=>{}));
for (const drawer of document.querySelectorAll('cart-drawer-component')) {
  drawer.addEventListener('dialog:open', () => clearAcceptance().catch(()=>{}));
}
